import { faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, Modal, Table } from 'react-bootstrap';

import es from '../../lang/es';

const PaymentInfo = props => {
    //Tomo los props
    const { show, handleClose, payment } = props;
    //Render
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <h4 className="modal-title">
                    <FontAwesomeIcon icon={ faInfoCircle} /> <strong>{ es.PAYMENTS.INFO }</strong>
                </h4>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12">
                        <div className="table-responsive">
                            <Table size="sm" borderless hover>
                                <thead className="thead-light">
                                    <th colSpan="2" className="text-left">{ es.PAYMENTS.DATA.toUpperCase() }</th>
                                </thead>
                                <tbody>
                                    {
                                        payment.payment_lot_id ? (
                                            <>
                                                <tr>
                                                    <td className="text-left"><strong>{ es.FIELDS.LOT_ID }</strong></td>
                                                    <td className="text-left">{ payment.payment_lot.identificator }</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-left"><strong>{ es.FIELDS.LOT_STATE }</strong></td>
                                                    <td className="text-left">
                                                        <span className={`badge badge-${payment.payment_lot.state.style}`}>
                                                            { payment.payment_lot.state.name }
                                                        </span>
                                                    </td>
                                                </tr>
                                                {
                                                    payment.payment_lot.show_info ? (
                                                        payment.payment_lot.notification ? (
                                                            <>
                                                                <tr>
                                                                    <td className="text-left"><strong>{ es.FIELDS.DESCRIPTION }</strong></td>
                                                                    <td className="text-left">{ payment.payment_lot.notification.description }</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-left"><strong>{ es.FIELDS.PAYMENT_DATE }</strong></td>
                                                                    <td className="text-left">
                                                                        { payment.payment_lot.notification.payment_date }
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-left"><strong>{ es.FIELDS.PAYMENT_TYPE }</strong></td>
                                                                    <td className="text-left">{ payment.payment_lot.notification.type }</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-left"><strong>{ es.FIELDS.PAYMENT_METHOD }</strong></td>
                                                                    <td className="text-left">{ payment.payment_lot.notification.payment_method }</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-left"><strong>{ es.FIELDS.AMOUNT }</strong></td>
                                                                    <td className="text-left">$ { payment.payment_lot.notification.amount }</td>
                                                                </tr>
                                                            </>
                                                        ) : (
                                                            <tr>
                                                                <td className="text-left"><strong>{ es.FIELDS.CLOSE_DATE }</strong></td>
                                                                <td className="text-left">{ payment.payment_lot.closed_at }</td>
                                                            </tr>
                                                        )
                                                    ) : null
                                                }
                                            </>
                                        ) : null
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <FontAwesomeIcon icon={ faTimes } /> { es.CLOSE }
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PaymentInfo;